(function () {
  /* The script is linked from the head and from two sections: run it once only */
  if (window.__albeuxMotion) return;
  window.__albeuxMotion = true;
  var root = document.documentElement;
  root.classList.add('albeux-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Play the zoom, then release the extra graphics layer once it has finished */
  function reveal(el) {
    el.classList.add('is-in');
    setTimeout(function () { el.classList.add('is-done'); }, 1600);
  }
  /* Reveal a little before a tile reaches the screen so nothing ever waits for the animation */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px 6% 0px' }) : null;
  function zoom() {
    document.querySelectorAll('[data-zoom]:not([data-zoom-ready])').forEach(function (el) {
      el.setAttribute('data-zoom-ready', '1');
      if (io) io.observe(el); else reveal(el);
    });
  }
  /* The endless slow zooms (hero and collection tiles) rest while they are off screen */
  var watcher = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) e.target.removeAttribute('data-off'); else e.target.setAttribute('data-off', '');
    });
  }, { rootMargin: '160px' }) : null;
  function watch() {
    if (!watcher) return;
    document.querySelectorAll('.hero:not([data-watch]), [data-testid="collection-list"] .resource-list__item:not([data-watch])').forEach(function (el) {
      el.setAttribute('data-watch', '1');
      watcher.observe(el);
    });
  }
  /* New Silhouette: one bag at a time, endlessly.
     1. The bag arrives from the middle of the picture, fast, zooming in to its normal size (0.4s).
     2. It rests at normal size for a moment (0.6s).
     3. It zooms OUT slowly, like a dolly, for 3 seconds.
     4. It zooms out faster for a split second and disappears (0.3s).
     Then the next bag arrives from where this one went and does the same. */
  var T_IN = 400, T_REST = 600, T_DOLLY = 3000, T_OUT = 300;
  function slides() {
    document.querySelectorAll('[data-slides]:not([data-slides-ready])').forEach(function (box) {
      box.setAttribute('data-slides-ready', '1');
      var imgs = Array.prototype.slice.call(box.querySelectorAll('img'));
      if (!imgs.length) return;
      imgs.forEach(function (im) { im.loading = 'eager'; im.classList.remove('is-active'); im.style.opacity = '0'; });
      if (imgs.length < 2 || reduce || !imgs[0].animate) { imgs[0].style.opacity = '1'; return; }
      var total = T_IN + T_REST + T_DOLLY + T_OUT;
      var o1 = T_IN / total;
      var o2 = (T_IN + T_REST) / total;
      var o3 = (T_IN + T_REST + T_DOLLY) / total;
      var i = -1;
      var current = null;
      function next() {
        if (current) { try { current.cancel(); } catch (e) {} }
        i = (i + 1) % imgs.length;
        var img = imgs[i];
        current = img.animate([
          { opacity: 0, transform: 'scale(0.5)', offset: 0, easing: 'cubic-bezier(.12,.8,.2,1)' },
          { opacity: 1, transform: 'scale(1)', offset: o1, easing: 'linear' },
          { opacity: 1, transform: 'scale(1)', offset: o2, easing: 'cubic-bezier(.4,.15,.55,1)' },
          { opacity: 1, transform: 'scale(0.86)', offset: o3, easing: 'cubic-bezier(.55,0,.9,.5)' },
          { opacity: 0, transform: 'scale(0.45)', offset: 1 }
        ], { duration: total, fill: 'both' });
        current.onfinish = next;
      }
      next();
    });
  }
  function hints() {
    document.querySelectorAll('[data-feature]:not([data-hint-ready])').forEach(function (sec) {
      sec.setAttribute('data-hint-ready', '1');
      var t = sec.querySelector('[data-track]');
      if (!t) return;
      t.addEventListener('scroll', function () { if (t.scrollLeft > 16) sec.classList.add('is-scrolled'); }, { passive: true });
    });
  }
  function init() { zoom(); slides(); hints(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  setTimeout(function () {
    document.querySelectorAll('[data-zoom]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0 && r.right > 0 && r.left < window.innerWidth) reveal(el);
    });
    watch();
  }, 800);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-peek]');
    if (b) {
      e.preventDefault();
      var card = b.closest('[data-zoom]');
      var d = card && card.querySelector('dialog');
      if (d && d.showModal && !d.open) d.showModal();
      return;
    }
    var c = e.target.closest('[data-peek-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('albeux-peek')) e.target.close();
  });
  /* Faster page changes: a page is fetched in the background only when a link is about to be used (hover on a computer, touch on a phone).
     Only the safe prefetch is used (no pre-rendering): a pre-rendered product page can wake up half-started (frozen picture, dots shown as numbers, no swiping).
     Speed pass (31 Oct 2026): product pages used to be fetched "as soon as the link is on screen" on the home page and product pages. On the home page that is a
     dozen or more whole pages downloaded while the photographs are still loading, which slows a phone down. Now every page waits until its link is about to be used. */
  try {
    var where = { and: [{ href_matches: '/*' }, { not: { href_matches: ['/cart*', '/checkout*', '/account*', '/*add*'] } }] };
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      var s = document.createElement('script');
      s.type = 'speculationrules';
      s.textContent = JSON.stringify({
        prefetch: [
          { where: { href_matches: '/products/*' }, eagerness: 'moderate' },
          { where: where, eagerness: 'moderate' }
        ]
      });
      document.head.appendChild(s);
    } else {
      var seen = {};
      var skipPaths = ['/cart', '/checkout', '/account'];
      var warm = function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || a.origin !== location.origin || seen[a.href] || a.target === '_blank') return;
        for (var i = 0; i < skipPaths.length; i++) { if (a.pathname.indexOf(skipPaths[i]) === 0) return; }
        seen[a.href] = 1;
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = a.href;
        document.head.appendChild(l);
      };
      document.addEventListener('pointerover', warm, { passive: true });
      document.addEventListener('touchstart', warm, { passive: true });
    }
  } catch (err) {}
})();